import { useEffect } from "react"
import { TabsReportes } from "../../components/tabs/TabsReportes"


export const ReportesIncidencia = () => {
    const reportes = [
        {tituloReporte: 'Reporte de incidencias por empresa', nomReporte: 'Reporte 001', codigoReporte: 'RP001' },
        {tituloReporte: 'Reporte de incidencias por personal', nomReporte: 'Reporte 002', codigoReporte: 'RP002' },
        {tituloReporte: 'Reporte de incidencias por equipo', nomReporte: 'Reporte 003', codigoReporte: 'RP003' },
        {tituloReporte: 'Reporte de eficiencia de servicios', nomReporte: 'Reporte 004', codigoReporte: 'RP004' },
        {tituloReporte: 'Reporte de incidencias por unidad', nomReporte: 'Reporte 005', codigoReporte: 'RP005' },
        {tituloReporte: 'Reporte de incidencias por intensidad', nomReporte: 'Reporte 006', codigoReporte: 'RP006' },
    ]

    useEffect(() => {
        document.title = "PGI | Consultas y reportes";
    },[])

    return(
        <div className="px-3 py-5 relative top-0 bottom-0 left-0 right-0 contenedor-tabla w-full h-full overflow-hidden">
            <TabsReportes listaMenus={reportes}></TabsReportes>
        </div>
    )
} 